// JsFromRoutes CacheKey d89d76da083b733906aadb239443d256
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const inspections = {
  create: definePathHelper("post", "/inspections"),
  new: definePathHelper("get", "/inspections/new"),
};
